import { Logger } from "@viamap/viamap2-common";
import { PropertyInfoInterface } from "./PropertyInfoInterface";

export type SFEGeoCodeResult = any;

export class GeocodeSFEInterface {

   static async geocode(
      sfe: number[],
      callback: (result: SFEGeoCodeResult[]) => void,
      statusStarted: (noGeoCodeStarted: number) => void,
      statusCompleted: (noGeoCodeCompleted: number, stats: any) => void) {
      let completed = 0;
      let stats: Record<string, number> = {};
      let results: SFEGeoCodeResult[] = [];


      function startIterationWLimitedConcurrency(i: number, activeRequestsLimit: number) {
         let sfeNr = sfe[i];

         let activeRequests = (i + 1) - completed;
         if (activeRequests > activeRequestsLimit) {
            // Delay starting new requests before the queue is shorter. Test again in 1 sek.
            let delay = 1000 * 1;
            setTimeout(
               () => {
                  startIterationWLimitedConcurrency(i, activeRequestsLimit);
               },
               delay);
         } else {
            statusStarted(i + 1);
            GeocodeSFEInterface.washFunctionGsearch(sfeNr, i).then((response) => {

               completed += 1;
               const q = response.dataquality;
               stats = { ...stats, [q]: stats[q] + 1 };
               statusCompleted(completed, stats);

               let index = response.idx;
               // Store result in the right index
               results[index] = response;

               // Done?
               if (completed === sfe.length) {
                  Logger.logInfo("CadasterInterface", "geocode", "Completed. Stats: " + JSON.stringify(stats));
                  callback(results);
               }
            });
            // Start next request, if any
            if (i + 1 < sfe.length) {
               startIterationWLimitedConcurrency(i + 1, activeRequestsLimit);
            }
         }
      }
      startIterationWLimitedConcurrency(0, 50);
   }

   private static async washFunctionGsearch(sfeNumber: number, idx: number): Promise<SFEGeoCodeResult> {
      if (!sfeNumber || sfeNumber <= 0) {
         return {
            "input": `${sfeNumber}`,
            "idx": idx,
            "dataquality": "error",
            "dataqualityNote": "Invalid SFE number",
         }
      }

      let geojson: any = {}
      geojson = await PropertyInfoInterface.getGeojsonOfSFE(sfeNumber).catch((err) => {
         console.error("(WashFunctionGsearch: getSFEFromMatrikel): " + err);
         return { features: [] };
      });

      if (!geojson || !geojson.features || geojson.features.length === 0) {
         return {
            "input": `${sfeNumber}`,
            "idx": idx,
            "dataquality": "bad",
            "sfeejendomsnr": sfeNumber,
            "dataqualityNote": "No geometry found for SFE number",
         }
      };
      return {
         "input": `${sfeNumber}`,
         "idx": idx,
         "dataquality": "good",
         "sfeejendomsnr": sfeNumber,
         "dataqualityNote": "Ok",
         ...geojson && { geoJson: geojson }
      }
   }
}